import { Outlet } from 'react-router-dom';

function OrdersLayout() {
    return <Outlet />;
}

export default OrdersLayout;